const SectionEvents = Class(
	/**
	 * @lends SectionEvents
	 * @extends Section
	 */
	{
		bodyClass: 'small-nav',
		menuItem: 'events',

		draw: function() {
			this.node = mkE({
				tag: 'div',
				id: 'SectionEvents',
				els: [
					{
						tag: 'div',
						id: 'hero',
						className: 'mb-5 container fade',
						els: [
							{
								tag: 'h1',
								innerHTML: t('b2b.events.hero.h2')
							},
							{
								tag: 'p',
								innerHTML: t('b2b.events.hero.p')
							},
							{
								tag: 'div',
								className: 'hero__btn',
								els: [
									{
										tag: 'a',
										className: 'button button-pink',
										href: D.url('/contact-us?ref=events'),
										text: t('b2b.home.hero.btn')
									}
								]
							},
							D.CSS.brTablet ? '' : {
								tag: 'div',
								className: 'hero__video',
								els: [
									{
										tag: 'video',
										autoplay: true,
										muted: true,
										loop: true,
										src: '/assets/b2b/images/events/vilki23.mp4',
										style: {
											width: '296px',
											height: '608px'
										}
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'container mb-5 events__concepts fade',
						els: [
							{
								tag: 'h2',
								className: 'mb-4',
								text: t('b2b.events.concepts.h1')
							},
							{
								tag: 'div',
								className: 'concepts',
								els: (() => {
									let els = [];
									for (let i = 1; i <= 6; i++) {
										if (i % 2) {
											els.push({
												tag: 'div',
												className: 'concepts--row',
												els: []
											});
										}
										els[Math.ceil(i / 2) - 1].els.push({
											tag: 'div',
											className: 'concept',
											onclick: this._onClickConcept,
											els: [
												{
													tag: 'div',
													className: `concept__image concept__image--${i}`,
													els: [
														{
															tag: 'p',
															els: [
																{
																	tag: 'span',
																	text: t(`b2b.events.concepts.item.${i}.text`)
																}
															]
														}
													]
												},
												{
													tag: 'div',
													className: 'h3',
													innerHTML: t(`b2b.events.concepts.item.${i}.h3`)
												},
												{
													tag: 'a',
													className: 'close',
													els: [
														D.svgIcon('close')
													]
												}
											]
										});
									}
									return els;
								})()
							}
						]
					},
					{
						tag: 'div',
						className: 'container-wide mb-5 events__packs fade',
						els: [
							new SectionEvents.Packs()
						]
					},
					{
						tag: 'div',
						className: 'events__list',
						id: 'events_list',
						els: [
							{
								tag: 'div',
								className: 'container events__list__header',
								els: [
									{
										tag: 'h2',
										text: t('b2b.events.list.h1')
									},
									{
										tag: 'p',
										text: t('b2b.events.list.h2')
									}
								]
							},
							new T.EventsList(this, {
								list: {
									count: D.CSS.brTablet ? 4 : 5,
									featured: false,
									simpleHeader: true
								}
							})
						]
					},
					{
						tag: 'div',
						className: 'mb-5 fade',
						els: [
							{
								tag: 'div',
								className: 'container',
								els: [
									{
										tag: 'h2',
										className: 'mb-2',
										text: t('b2b.events.how-to.h1')
									},
									{
										tag: 'p',
										text: t('b2b.events.how-to.h2')
									}
								]
							},
							this._howTo = new T.HowTo([
								'matchmaker',
								'g-spot',
								'explorer',
								'sprinter',
								'hunter',
								'groupie',
								'expert',
								'detective',
								'coder',
								'golddigger'
							], 'matchmaker')
						]
					},
					{
						tag: 'div',
						className: 'container mb-5 events__steps fade',
						els: [
							{
								tag: 'h2',
								className: 'h1 mb-4',
								text: t('b2b.events.steps.h1')
							},
							{
								tag: 'div',
								className: 'steps__column',
								els: [
									{
										tag: 'div',
										className: 'steps column',
										els: [
											this._drawStepInfo('game', 0),
											this._drawStepInfo('game', 1),
											this._drawStepInfo('game', 2),
											this._drawStepInfo('game', 3)
										]
									},
									D.CSS.brTablet ? '' : {
										tag: 'video',
										autoplay: true,
										muted: true,
										loop: true,
										src: '/assets/b2b/images/events/start.mp4',
										//loading: 'lazy',
										style: {
											width: '402px',
											height: '814px'
										}
									}
								]
							}
						]
					},
					new T.FAQ({
						title: t('b2b.events.faq.title'),
						prefix: 'b2b.events.faq',
						className: 'container mb-5 fade'
					})
				]
			}).append(this.layout.ct());

			this.apiCall.call();
		},

		_onClickConcept(e) {
			if (!D.CSS.brMobile) {
				return;
			}
			const sibling = e.currentTarget.previousElementSibling || e.currentTarget.nextElementSibling;
			if (!sibling) {
				return;
			}
			if (existsClassName(e.currentTarget, 'concept--active')) {
				removeClassName(e.currentTarget, 'concept--active');
				removeClassName(sibling, 'concept--hidden');
			} else {
				addClassName(e.currentTarget, 'concept--active');
				addClassName(sibling, 'concept--hidden');
			}
			let item = e.currentTarget.querySelector('span');
			while (item.offsetHeight > item.parentElement.clientHeight) {
				item.parentElement.style.width = item.parentElement.offsetWidth + 5 + 'px';
				if (item.parentElement.offsetWidth > item.parentElement.parentElement.offsetWidth) {
					break;
				}
			}
		},

		_drawStepInfo(type, index) {
			let key = 'b2b.events.steps.info.' + type + '.' + index;
			let list = [];
			for (let i = 0; i < 3; i++) {
				list.push({
					tag: 'li',
					text: t(key + '.' + 'list' + i)
				});
			}

			return mkE({
				tag: 'div',
				className: 'step step-' + type + '-' + index,
				els: [
					{
						tag: 'div',
						className: 'image'
					},
					{
						tag: 'div',
						className: 'list data',
						els: [
							{
								tag: 'h4',
								className: 'caption',
								text: t(key + '.' + 'title')
							},
							{
								tag: 'ul',
								className: 'text',
								els: list
							}
						]
					}
				]
			});
		},

		onShow() {
			this.fadeOnShow();
		},

		onScroll() {
			this.fadeOnScroll();
		}

	},
	Section
);

/**
 * @class
 * @param {SectionEvents.Packs.Par} par
 * @extends mkE.Base
 */
SectionEvents.Packs = Class(
	/**
	 * @lends {SectionEvents.Packs#}
	 */
	{
		ITEMS: 2,

		/** @type {SectionEvents.Packs.Par} */
		par: null,

		_items: {},
		_activeId: null,

		/** @param {SectionEvents.Packs.Par} par */
		__construct(par) {
			this.par = par;

			for (let i = 1; i <= this.ITEMS; i++) {
				this._items[i] = {menuNode: null, contentNode: null};
			}

			this.node = mkE({
				tag: 'div',
				className: 'packs',
				els: [
					{
						tag: 'div',
						className: 'packs__menu',
						els: (() => {
							let els = [];
							for (let i = 1; i <= this.ITEMS; i++) {
								els.push(
									this._items[i].menuNode = mkE({
										tag: 'a',
										onclick: this.selectPack.bind(this, i),
										els: [
											{
												tag: 'div',
												className: 'h2',
												text: t(`b2b.events.packs.${i}.menu.title`)
											},
											{
												tag: 'div',
												className: 'sub',
												text: t(`b2b.events.packs.${i}.menu.sub`, '')
											}
										]
									})
								);
							}
							return els;
						})()
					},
					{
						tag: 'div',
						className: 'packs__items',
						els: (() => {
							let els = [];
							for (let i = 1; i <= this.ITEMS; i++) {
								els.push(
									this._items[i].contentNode = mkE({
										tag: 'div',
										className: 'item',
										els: (() => {
											let els = [];
											for (let j = 1; j <= 6; j++) {
												els.push({
													tag: 'article',
													className: `item__row item__row_${i}_${j}`,
													els: [
														{
															tag: 'div',
															className: 'h4',
															text: t(`b2b.events.packs.${i}.rows.${j}.title`)
														},
														{
															tag: 'p',
															text: t(`b2b.events.packs.${i}.rows.${j}.descr`)
														}
													]
												});
											}
											return els;
										})()
									})
								);
							}
							return els;
						})()
					}
				]
			});
			this.selectPack(1);
		},

		selectPack(id) {
			if (this._activeId === id) {
				return;
			}
			if (this._activeId !== null) {
				removeClassName(this._items[this._activeId].menuNode, 'active');
				removeClassName(this._items[this._activeId].contentNode, 'active');
				removeClassName(this._items[this._activeId].contentNode, `pack--${this._activeId}`);
			}
			this._activeId = id;
			addClassName(this._items[this._activeId].menuNode, 'active');
			addClassName(this._items[this._activeId].contentNode, 'active');
			addClassName(this._items[this._activeId].contentNode, `pack--${this._activeId}`);
		}

	},
	mkE.Base
);
